export type SupportedFeature = {
    usageKey: "RevealProduct" | "RevealSupplier" | "ProcessDocument" | "RFQsSent";
    limitKey: "maxProductsRevealed" | "maxSuppliersRevealed" | "maxDocumentsProcessed" | "maxRFQsSent";
    name: string;
    icon: React.ReactNode;
    prerelease?: string | null;
    billedOn: string;
};

export enum Plans {
    Trial = "Trial",
    Starter = "Starter",
    Lite = "Lite",
    Professional = "Professional",
    ProfessionalTrial = "Professional Trial",
    Business = "Business",
    Enterprise = "Enterprise"
}

export enum BilledOn {
    DocumentProcessed = "Documents Processed",
    RFQsSent = "RFQs Sent",
    ProductsViewed = "Products Viewed",
    SuppliersRevealed = "Suppliers Revealed"
}
